<div class="toolbar set-flex-res">
    <div class="title-side">
        <h3 class="toolbar-title accent">{{ 'PAGE.PURCHASE.TITLE' | translate }}: <span class="system">{{ "SYSTEM." + system | translate }}</span></h3>
        <small>{{ 'PUBLIC.TIME_IN_CAMBODIA' | translate }} {{ liveTime }}</small>
    </div>
</div>
<mat-horizontal-stepper [selectedIndex]="isContinueToPayment ? 3 : null" [linear]="true" color="accent" class="stepper tr" id="stepper" (selectionChange)="handleStepChange($event)" #stepper>
    <!-- STEP 1 -->
    <mat-step [stepControl]="stepOneFormGroup" state="purchasing" class="purchasing" [completed]="stepOneFormGroup.valid">
        <ng-template matStepLabel>
            <span class="text-label">{{ 'PAGE.PURCHASE.STEPPER.SELECT_ENTRY_DATE' | translate }}</span>
            <span class="tooltip-text" matTooltipClass="bg-accent" [matTooltip]="'PAGE.PURCHASE.STEPPER.SELECTION' | translate"></span>
            <button mat-button class="tooltip-text large-device"></button>
        </ng-template>
        <form [formGroup]="stepOneFormGroup" class="purchasing">
            <p class="legend lt" color="accent">
                <mat-icon svgIcon="invoice"></mat-icon>
                <span class="primary">{{ 'LABEL.SELECT_TICKET_TYPE' | translate }}</span>
                <span class="required">*</span>
            </p>
            <div class="ticket-types" *ngIf="ticketTypes && ticketTypes.length">
                <ng-container *ngFor="let type of ticketTypes">
                    <app-ticket-type [price]="type.price" [type]="type.num_day" formControlName="num_day" [value]="type.num_day"></app-ticket-type>
                </ng-container>
            </div>
            <p class="legend lt">
                <mat-icon svgIcon="dates" color="accent"></mat-icon>
                <span>{{ 'LABEL.SELECT_ENTRY' | translate }}</span>
                <span class="required">*</span>
            </p>
            <!-- Noted -->
            <p class="note">
                <span class="warn bold mr">{{ 'LABEL.NOTE' | translate }}</span>
                <span class="warn">
                  {{passtxt | translate}}
              </span>
            </p>
            <div class="date">
                <div class="calendar flex-col flex-mc">
                    <mat-card class="calendar-card tr" color="accent">
                        <mat-calendar #calendar [minDate]="validDate" [maxDate]="maxDate" (selectedChange)="selectMultipleDates($event, calendar)" [dateClass]="isSelected">
                        </mat-calendar>
                        <div class="border-divider">
                            <mat-divider></mat-divider>
                        </div>
                        <div class="divider-container">
                            <div class="today-container">
                                <span class="date-today">{{'LABEL.TODAY' | translate }}: {{ setDateToday_DD_MMM_YYYY(currentDate)}}</span>
                                <button mat-button class="btn-clear" (click)="clearDates()">
                                      <mat-icon svgIcon="clear"></mat-icon>
                                      <span>{{ 'LABEL.CLEAR' | translate }}</span>
                                  </button>
                            </div>
                        </div>
                    </mat-card>

                    <div *ngIf="dayControl.errors?.overday" class="warning-card">
                        <mat-card class="sms-card" appearance="outlined">
                            <mat-icon>error</mat-icon>
                            <mat-card-content class="ml-5">{{'MSG.DATE_CAN_PURCHASE' | translate }}</mat-card-content>
                        </mat-card>
                    </div>
                </div>
            </div>
        </form>
        <div class="ticket-container">
            <div class="notification">
                <div class="btn-group action mt-5">
                    <button (click)="onCancel()" mat-flat-button class="button-cancel mat-custom-btn">
                  <mat-icon class="mat-icon" >arrow_back_ios</mat-icon>
                  {{ 'LABEL.CANCEL' | translate }}
                </button>
                    <button color="accent" class="next mat-custom-btn" mat-flat-button matStepperNext [disabled]="!this.ticketForm.value.length" (click)="stepOneValidatorMessage()">
                    {{ 'LABEL.NEXT' | translate }} <mat-icon class="mat-icon">arrow_forward_ios</mat-icon>
                </button>
                </div>
            </div>
        </div>
    </mat-step>
    <!-- end -->

    <!-- STEP 2 -->
    <mat-step state="number-ticket" [stepControl]="ticketForm" [completed]="hasTicket.value || isEdit">
        <ng-template matStepLabel>
            <span class="text-label">{{ 'PAGE.PURCHASE.STEPPER.ENTER_NUMBER_TICKET' | translate }}</span>
            <button (click)="stepOneValidatorMessage()" mat-button class="tooltip-text" matTooltipClass="bg-accent" [matTooltip]="'PAGE.PURCHASE.STEPPER.TICKETS' | translate"></button>
            <button (click)="stepOneValidatorMessage()" mat-button class="tooltip-text large-device"></button>
        </ng-template>
        <div class="purchasing" #stepTicket>
            <p class="legend lt">
                <mat-icon svgIcon="tickets" color="accent"></mat-icon>
                <span>{{ 'PAGE.PURCHASE.STEPPER.ENTER_NUMBER_TICKET' | translate }} </span>
            </p>
            <!-- Noted -->
            <p class="note">
                <span class="warn bold mr">{{ 'LABEL.NOTE' | translate }}</span>
                <span class="warn">
              <ul class="warn">
                <li>{{ 'MSG.TICKET_VARIABLE' | translate: { num_day: numDay } }}</li>
                <li>{{ 'MSG.FREE_ENTRY' | translate }}</li>
                <li>
                  {{ (isOneDayPass ? ( isAngkor ? ('MSG.ENTRIES_TEMPLE' | translate) : ('MSG.SINGLE_ENTRY_ONLY' | translate)) + ', ' : '') + ('MSG.NON_REFUNDABLE' | translate) + ', ' + ('MSG.NON_TRANSFERABLE' | translate) }}
                </li>
              </ul>
            </span>
            </p>
            <div class="ticket-container">
                <div class="notification">
                    <div class="tickets">
                        <ng-container *ngFor="let ticket of ticketForm.value; let i = index">
                            <div class="card">
                                <div class="card-body">
                                    <span>{{setDate_Ticket(ticket.date)}}</span>
                                </div>
                                <div class="card-btn">
                                    <button class="btn-number minus-ticket" mat-button [ngClass]="{ 'disabled-btn': ticket.numOfTicket == 1 }" [disabled]="ticket.numOfTicket == 1" (click)="decrementTicket(i)"><mat-icon svgIcon="minus"></mat-icon>
                                </button>
                                    <p class="number-ticket btn-number"><strong class="accent">{{ticket.numOfTicket}}</strong></p>
                                    <button class="btn-number increas-ticket" mat-button [ngClass]="{ 'disabled-btn':ticket.numOfTicket == MAX_TICKETS }" [disabled]="ticket.numOfTicket == MAX_TICKETS" (click)="incrementTicket(i, ticket.date)"><mat-icon svgIcon="increase"></mat-icon>
                                </button>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    <!-- Action Button -->
                    <div class="btn-group action btn-flex mt-5 mt-0">
                        <button (click)="onCancel()" mat-flat-button class="button-cancel mat-custom-btn">
                      <mat-icon matPrefix>arrow_back_ios</mat-icon>
                    {{ 'LABEL.CANCEL' | translate }}
                  </button>
                        <div class="action-right">
                            <button color="accent" class="mat-custom-btn btn-back mr-5" mat-flat-button matStepperPrevious>
                      <mat-icon class="mat-icon">arrow_back_ios</mat-icon>
                      {{ 'LABEL.BACK' | translate }}
                    </button>
                            <button color="accent" class="next mat-custom-btn" mat-flat-button matStepperNext (click)="oneDayValidator()">
                        {{ 'LABEL.NEXT' | translate }}
                        <mat-icon class="mat-icon">arrow_forward_ios</mat-icon>
                    </button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </mat-step>
    <!-- END -->

    <!-- STEP 3 -->
    <mat-step state="visitors-information" [stepControl]="stepThreeFormGroup" [completed]="stepThreeFormGroup.get('visitors').valid">
        <ng-template matStepLabel>
            <span class="text-label">{{ 'PAGE.PURCHASE.STEPPER.TICKETS' | translate }}</span>
            <button (click)="stepOneAndTwoValidatorMessage()" mat-button class="tooltip-text" matTooltipClass="bg-accent" [matTooltip]="'PAGE.PURCHASE.STEPPER.TICKETS' | translate"></button>
            <button (click)="stepOneAndTwoValidatorMessage()" mat-button class="tooltip-text large-device"></button>
        </ng-template>
        <div class="purchasing" #stepTicket>
            <p class="legend lt">
                <mat-icon svgIcon="visitor-info" class="primary"></mat-icon>
                <span>{{ 'PAGE.PURCHASE.STEPPER.TICKETS' | translate }} </span>
            </p>
            <!-- Noted  -->
            <p class="note" *ngIf="!isOneDayPass && (isAngkor || isKohker)">
                <span class="warn bold mr">{{ 'LABEL.NOTE' | translate }}</span>
                <span class="warn">{{'MSG.PHOTO_NOTE' | translate}}</span>
            </p>
            <div class="photo-required" *ngIf="!isOneDayPass && (isAngkor || isKohker)">
                <mat-accordion>
                    <mat-expansion-panel [expanded]="true" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                        <mat-expansion-panel-header class="panel-header">
                            <mat-panel-title class="bold"> {{'LABEL.PHOTO_GUIDE' | translate}} </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="note">
                            <div class="notification">
                                <ul class="msg-list">
                                    <li class="warn">{{'PHOTO_GUID.BLACK_WHITE' | translate}}</li>
                                    <li class="warn">{{'PHOTO_GUID.CLEAR_FACE' | translate}}</li>
                                </ul>
                                <ul class="image-list">
                                    <li><img src="../../../assets/img/tooltip/tooltip_1.svg" alt="tootip image 1"></li>
                                    <li><img src="../../../assets/img/tooltip/tooltip_2.svg" alt="tootip image 2"></li>
                                </ul>
                                <ul class="msg-list">
                                    <li class="warn">{{'PHOTO_GUID.WITHOUT_OF_FACE' | translate}}</li>
                                    <li class="warn">{{'PHOTO_GUID.TAKEN_WITHIN_THREE_MONTH' | translate}}</li>
                                </ul>
                                <ul class="image-list">
                                    <li><img src="../../../assets/img/tooltip/tooltip_3.svg" alt="tootip image 3"></li>
                                    <li><img src="../../../assets/img/tooltip/tooltip_4.svg" alt="tootip image 4"></li>
                                </ul>
                                <ul class="msg-list">
                                    <li class="warn">{{'PHOTO_GUID.NO_HAND_GESTURES' | translate}}</li>
                                    <li class="warn">{{'PHOTO_GUID.FAKE_PHOTO' | translate}}</li>
                                </ul>
                                <ul class="image-list">
                                    <li><img src="../../../assets/img/tooltip/tooltip_5.svg" alt="tootip image 5"></li>
                                    <li><img src="../../../assets/img/tooltip/tooltip_6.svg" alt="tootip image 6"></li>
                                </ul>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>

            <div class="ticket-container">
                <div class="notification">
                    <ng-container *ngFor="let ticket of visitorForm.controls; let i = index">
                        <div class="ticket-group">
                            <div class="ticket-header">
                                <div class="h-data">
                                    <label class="key">{{'PAGE.ORDER.HOME.LIST.HEADER.VISIT_DATE' | translate}} : </label>
                                    <span class="data">{{getMonth(ticket.value.date)}}</span>
                                </div>
                                <div class="h-data">
                                    <label class="key">{{'PAGE.ORDER.HOME.LIST.HEADER.EXPIRE_DATE' | translate}} : </label>
                                    <span class="data">{{getMonth(getExpiryDate(ticket.value.date))}}</span>
                                </div>
                                <div class="h-data">
                                    <label class="key">{{'LABEL.NUMBEROFTICKET' | translate}} : </label>
                                    <span class="data">{{ticket.value.numOfTicket || 0}}</span>
                                </div>
                            </div>
                            <div class="ticket-divider">
                                <mat-divider></mat-divider>
                            </div>
                            <div class="ticket-card">
                                <app-ticket-card @fadeOpInOut [nationalities]="countries" [isKohker]="isKohker || isChongKhneas || isOneDayPass" [filteredNationalityArray]="countries" [groupAges]="groupsAge" *ngFor="let vis of ticket.get('visitors').controls; let num = index" [filePickerKey]="i"
                                    [fileTicketKey]="num" [index]="isChongKhneas ? (num + 1) : null" [formGroup]="vis" [enableRemove]="isCanRemoveTicket" [lang]="currentLang">
                                </app-ticket-card>
                            </div>
                        </div>
                    </ng-container>

                    <div class="btn-group action btn-flex mt-5 mt-0">
                        <button (click)="onCancel()" mat-flat-button class="button-cancel mat-custom-btn">
                    <mat-icon matPrefix>arrow_back_ios</mat-icon>
                  {{ 'LABEL.CANCEL' | translate }}
                </button>
                        <div class="action-right">
                            <button color="accent" class="mat-custom-btn btn-back mr-5" mat-flat-button matStepperPrevious>
                    <mat-icon class="mat-icon">arrow_back_ios</mat-icon>
                    {{ 'LABEL.BACK' | translate }}
                  </button>
                            <button color="accent" class="next mat-custom-btn" mat-flat-button matStepperNext (click)="visitorsValidator()">
                      {{ 'LABEL.NEXT' | translate }}
                      <mat-icon class="mat-icon">arrow_forward_ios</mat-icon>
                  </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mat-step>
    <!-- END -->

    <!-- Confirmation -->
    <mat-step [label]="'PAGE.PURCHASE.STEPPER.CONFIRM' | translate" state="confirm" [completed]="isContinueToPayment" [stepControl]="isAgree">
        <ng-template matStepLabel>
            <span class="text-label">{{ 'PAGE.PURCHASE.STEPPER.CONFIRM' | translate }}</span>
            <button (click)="stepThreeValidatorMessage()" mat-button class="tooltip-text" matTooltipClass="bg-accent" [matTooltip]="'PAGE.PURCHASE.STEPPER.CONFIRM' | translate"></button>
            <button (click)="stepThreeValidatorMessage()" mat-button class="tooltip-text large-device"></button>
        </ng-template>
        <div class="purchasing">
            <!-- Ticket Information -->
            <p class="legend lt">
                <mat-icon svgIcon="paper"></mat-icon>
                <span>{{ 'PAGE.PURCHASE.STEPPER.CONFIRM' | translate }}</span>
            </p>
            <div class="ticket-container">
                <div class="flex-col confirms">
                    <app-order-card-info [passType]="system" [typeName]="tickerOrderType?.name" [quantity]="order?.num_ticket" [totalPrice]="totalPrice" [startDate]="day" [endDate]="enddate" [isPickup]="isPickup" [numDay]="tickerOrderType?.num_day" [isView]="false">
                    </app-order-card-info>
                </div>
            </div>
            <!-- Visitors Table -->
            <h3 class="legend lt mt">
                <mat-icon svgIcon="visitor_color"></mat-icon>
                <span>{{ 'PAGE.PURCHASE.STEPPER.TICKETS' | translate }}</span>
            </h3>
            <div class="ticket-container">
                <div class="visitor-summary">
                    <div class="table-wrapper">
                        <ng-container *ngIf="isOneDayPass; else oneAndSevenDaysPass">
                            <table mat-table [dataSource]="tickets" class="visitors-table tr">
                                <ng-container matColumnDef="no">
                                    <th class="header-cell" mat-header-cell *matHeaderCellDef align="center">{{ "TABLE.NO" | translate }}</th>
                                    <td mat-cell *matCellDef="let i = index" align="center"> {{ i + 1 }}</td>
                                </ng-container>

                                <!-- Start Date -->
                                <ng-container matColumnDef="start_date">
                                    <th class="header-cell" mat-header-cell *matHeaderCellDef> {{ 'PAGE.ORDER.HOME.LIST.HEADER.VISIT_DATE' | translate }} </th>
                                    <td mat-cell *matCellDef="let visitor">
                                        {{getMonth(visitor.ticket?.start_date)}}
                                    </td>
                                </ng-container>

                                <!-- End Date -->
                                <ng-container matColumnDef="end_date">
                                    <th class="header-cell" mat-header-cell *matHeaderCellDef> {{ 'PAGE.ORDER.HOME.LIST.HEADER.EXPIRE_DATE' | translate }} </th>
                                    <td mat-cell *matCellDef="let visitor">
                                        {{getMonth(visitor.ticket?.expired_date)}}
                                    </td>
                                </ng-container>

                                <!-- Nationality -->
                                <ng-container matColumnDef="national">
                                    <th class="header-cell" mat-header-cell *matHeaderCellDef> {{ 'TABLE.NATIONALITY' | translate }} </th>
                                    <td mat-cell *matCellDef="let visitor">
                                        {{getNationalityByID(visitor.ticket?.nationality)}}
                                    </td>
                                </ng-container>
                                <tr class="header-row" mat-header-row *matHeaderRowDef="DISPLAY_COLUMN"></tr>
                                <tr mat-row *matRowDef="let row; columns:DISPLAY_COLUMN"></tr>
                            </table>
                        </ng-container>
                        <ng-template #oneAndSevenDaysPass>
                            <table mat-table [dataSource]="tickets" class="visitors-table tr">
                                <ng-container matColumnDef="no">
                                    <th class="header-cell" mat-header-cell *matHeaderCellDef align="center">{{ "TABLE.NO" | translate }}</th>
                                    <td mat-cell *matCellDef="let i = index" align="center"> {{ i + 1 }}</td>
                                </ng-container>

                                <!-- Image -->
                                <ng-container matColumnDef="image" *ngIf="!isKohker || !isOneDayPass">
                                    <th class="header-cell" mat-header-cell *matHeaderCellDef align="center"> {{ 'TABLE.PHOTO' | translate }} </th>
                                    <td mat-cell *matCellDef="let visitor" align="center">
                                        <div class="image-cont">
                                            <app-image class="avatar" [avatar]="true" [width]="50" [height]="50" alt="image profile" [id]="visitor.ticket?.photo"></app-image>
                                        </div>
                                    </td>
                                </ng-container>

                                <!-- Start Date -->
                                <ng-container matColumnDef="start_date">
                                    <th class="header-cell" mat-header-cell *matHeaderCellDef> {{ 'PAGE.ORDER.HOME.LIST.HEADER.VISIT_DATE' | translate }} </th>
                                    <td mat-cell *matCellDef="let visitor">
                                        {{getMonth(visitor.ticket?.start_date)}}
                                    </td>
                                </ng-container>

                                <!-- End Date -->
                                <ng-container matColumnDef="end_date">
                                    <th class="header-cell" mat-header-cell *matHeaderCellDef> {{ 'PAGE.ORDER.HOME.LIST.HEADER.EXPIRE_DATE' | translate }} </th>
                                    <td mat-cell *matCellDef="let visitor">
                                        {{getMonth(visitor.ticket?.expired_date)}}
                                    </td>
                                </ng-container>

                                <!-- Nationality -->
                                <ng-container matColumnDef="national">
                                    <th class="header-cell" mat-header-cell *matHeaderCellDef> {{ 'TABLE.NATIONALITY' | translate }} </th>
                                    <td mat-cell *matCellDef="let visitor">
                                        <!-- {{ 'NATIONALITIES.' + getNationalityByID(visitor.ticket?.nationality).nationality | translate }} -->
                                        {{getNationalityByID(visitor.ticket?.nationality)}}
                                    </td>
                                </ng-container>
                                <tr class="header-row" mat-header-row *matHeaderRowDef="DISPLAY_DEFAULT_COLUMN"></tr>
                                <tr mat-row *matRowDef="let row; columns: DISPLAY_DEFAULT_COLUMN"></tr>
                            </table>
                        </ng-template>
                    </div>
                </div>
                <div class="btn-group action step-3 mt-0">
                    <div class="agree opt lt">
                        <mat-checkbox id="agree" [formControl]="isAgree">{{ 'PUBLIC.I_AGREE' | translate }}</mat-checkbox>
                        <a class="accent" (click)="onAgree()" style="cursor: pointer; margin-left: 3px;">{{ 'PUBLIC.TERMS_AND_CON' | translate}}</a>
                    </div>
                    <div class="action-right">
                        <button color="accent" class="mat-custom-btn btn-back mr-5" mat-flat-button matStepperPrevious>
                  <mat-icon class="mat-icon">arrow_back_ios</mat-icon>
                  {{ 'LABEL.BACK' | translate }}
                </button>
                        <button color="accent" class="next mat-custom-btn" mat-flat-button matStepperNext [disabled]="!isAgree.value" (click)="onSetupPayment(order?._id, stepper)">
                    {{'LABEL.CHECK_OUT' | translate}}<mat-icon class="mat-icon">arrow_forward_ios</mat-icon>
                </button>
                    </div>
                </div>
            </div>
        </div>
    </mat-step>
    <!-- END -->

    <ng-template matStepperIcon="purchasing">
        <mat-icon class="stepper-icon">shopping_cart</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="number-ticket">
        <mat-icon class="stepper-icon">list_alt</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="visitors-information">
        <mat-icon class="stepper-icon">groups</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="confirm">
        <mat-icon class="stepper-icon">confirmation_number</mat-icon>
    </ng-template>
</mat-horizontal-stepper>

<!-- Turnstile reCAPTCHA -->
<div id="turnstile-widget"></div>

<!-- ABA Payment -->
<div id="aba_main_modal" class="aba-modal">
    <div class="aba-modal-content">
        <form method="POST" class="hidden" [action]="payment?.action_url" id="aba_merchant_request">
            <input type="text" *ngFor="let key of payment | keyvalue" type="hidden" [name]="key.key" [value]="key.value" [id]="key.key">
        </form>
    </div>
</div>

<!-- ACLEDA Payment -->
<form method="POST" class="hidden" id="_xpayTestForm" name="_xpayTestForm" [action]="actionUrl">
    <input *ngFor="let key of paymentKey" id="{{key}}" type="hidden" name="{{key}}" value="{{paymentInfo[key]}}" />
    <script>
        $(document).ready(function() {
            function disableBack() {
                window.history.forward()
            }
            window.onload = disableBack();
            window.onpageshow = function(evt) {
                if (evt.persisted) disableBack()
            }
        });
    </script>
</form>
